export default __webpack_public_path__ + "static/media/instacart-case.18ed1533.jpg";